import fetch from 'utils/fetch';

export const load = caseId => {
  return fetch(`/pco-manager/aast/cases/${caseId}/contract/accept`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(r => r.json());
};

export const update = (id, json) => {
  return fetch(`/pco-manager/aast/cases/${id}/contract/accept`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(json, (key, value) => {
      return value === '' ? undefined : value;
    }),
  });
};



// WEBPACK FOOTER //
// ./src/modules/saas/aast/case-contract/validation/api/index.js